import { getItem, setItem } from '@Utils/LocalStorage';
import { EDITOR_LIST_LOCAL_STORAGE_KEY } from './Constants';

const removeTargetEditorInLocalStorage = projectId => {
  const editorList = getItem(EDITOR_LIST_LOCAL_STORAGE_KEY);
  delete editorList[projectId];

  setItem(EDITOR_LIST_LOCAL_STORAGE_KEY, editorList);
};

export { removeTargetEditorInLocalStorage };
